import { IPivotStyles, IStackStyles, IStackTokens } from "@fluentui/react";

export const rowStackStyles: IStackStyles = {
  root: {
    // No explicit styles needed here, since rowProps is just layout props
  }
};

export const pivotStyles: IPivotStyles = {
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    margin: 20,
    maxWidth: "100%",
    overflowX: "auto"
  },
  link: {
    padding: "6px 16px",
    height: "32px",
    lineHeight: "20px",
    borderRadius: "8px",
    backgroundColor: "#d0e7f7",
    fontWeight: "bold",
    color: "#0078D4",
    transition: "all 0.3s",
    textDecoration: "none",
    flexShrink: 0,
    whiteSpace: "nowrap",
    selectors: {
      ":hover": {
        backgroundColor: "#d0e7f7"
      }
    }
  },
  linkIsSelected: {
    backgroundColor: "#0078D4",
    color: "white",
    textDecoration: "none"
  },
  linkContent: undefined,
  text: undefined,
  count: undefined,
  icon: undefined,
  linkInMenu: undefined,
  overflowMenuButton: undefined
};

export const tokens: { sectionStack: IStackTokens; spinnerStack: IStackTokens } = {
  sectionStack: {
    childrenGap: 10
  },
  spinnerStack: {
    childrenGap: 20
  }
};
